import React, { useState, useEffect, useRef } from 'react';

import { IoCaretDownOutline, IoCaretUpOutline } from 'react-icons/io5';
const StatusCustomDropdown = ({ options, value, onChange, name, idKey, displayKey, enableScrollEffect = false }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedValue, setSelectedValue] = useState(value);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    setSelectedValue(value);
  }, [value]);

  const handleToggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleSelectOption = (option) => {
    setSelectedValue(option[idKey]);
    setIsOpen(false);
    onChange({ target: { name, value: option[idKey] } });
  };

  useEffect(() => {
    if (!enableScrollEffect) return;

    const mainContainer = document.querySelector('.main_container');

    if (!mainContainer) return;

    if (isOpen) {
      // OPEN LOGIC
      setTimeout(() => {
        const dropdown = dropdownRef.current?.querySelector(
          '.custom-dropdown__options'
        );


        const mainContainer = document.querySelector('.main_container');

        console.log("Dropdown element:", dropdown);
        const dropdownHeight = dropdown?.offsetHeight || 20;
        const gap = 20;
        console.log("dropdownHeight", dropdownHeight);
        if (mainContainer) {
          mainContainer.style.paddingBottom = `${dropdownHeight + gap}px`;
          mainContainer.scrollTo({
            top: mainContainer.scrollHeight,
            behavior: 'smooth',
          });
        }
      }, 100);
    } else {
      // CLOSE LOGIC
      mainContainer.style.paddingBottom = '';
    }
  }, [isOpen, enableScrollEffect]);


  const selectedOption = options.find(option => option[idKey] === selectedValue);

  return (
    <div className="custom-dropdown" ref={dropdownRef}>
      <div className="custom-dropdown__selected" onClick={handleToggleDropdown}>
        {selectedOption ? selectedOption[displayKey] : 'Active'}
        <span className="custom-dropdown__caret">
          {isOpen ? <IoCaretUpOutline /> : <IoCaretDownOutline />}
        </span>
      </div>
      {isOpen && (
        <div className="custom-dropdown__options">
          {options.map((option) => (
            <div
              key={option[idKey]}
              className="custom-dropdown__option"
              onClick={() => handleSelectOption(option)}
            >
              {option[displayKey]}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default StatusCustomDropdown;